import * as React from 'react';
import { cn } from '../../lib/utils';

const Progress = React.forwardRef(({ className, value = 0, tone = 'primary', ...props }, ref) => {
  const clamped = Math.max(0, Math.min(100, Number(value) || 0));
  const tones = {
    primary: 'bg-primary',
    accent: 'bg-accent',
    success: 'bg-success',
    destructive: 'bg-destructive',
  };

  return (
    <div
      ref={ref}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={clamped}
      className={cn('relative h-1.5 w-full overflow-hidden rounded-pill bg-muted', className)}
      {...props}
    >
      <div
        className={cn('h-full rounded-pill transition-all duration-300 ease-out', tones[tone])}
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
});
Progress.displayName = 'Progress';

export { Progress };
